import React from "react";
import { Link } from "react-router-dom";

function SeasonFav() {
  const products = [
    {
      image: "assets/Seasonal-Fav/snitch-store053.jpg",
      name: "essentials",
    },

    {
      image: "assets/Seasonal-Fav/snitch-store054.jpg",
      name: "oversized",
    },
    {
      image: "assets/Seasonal-Fav/snitch-store055.jpg",
      name: "chinos",
    },
    {
      image: "assets/Seasonal-Fav/snitch-store056.jpg",
      name: "casual",
    },
  ];

  return (
    <section id="season-fav">
      <div className="p-3 md:p-0 container">
        <div className="p-4 w-full text-center heading">
        <h1 className="font-primaryFont text-3xl uppercase">Seasonal Fav's🌤️</h1>
        </div>
        
        <div className="flex flex-wrap justify-start items-center card-container">
          {products.map((product, index) => {
            return (
              <div key={product.id || index} className="relative flex-wrap flex-shrink-0 p-2 w-1/2 md:w-1/4 cursor-pointer overflow-hidden card">
                <Link to={`/products?search=${encodeURIComponent(product.name)}`} >
                <img src={product.image} alt=""     className="brightness-normal hover:brightness-75 transform transition-transform duration-500 scale-100 hover:scale-110"
/>

                <span className="bottom-2 left-2 absolute bg-black/50 p-2 font-bold font-secondaryFont text-white">{product.name}</span>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
      
    </section>
  );
}

export default SeasonFav;
